import React, { useState } from "react";
import { pushNotif, emergency, popUp, sliders } from "../../assets/images";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { PROD_LINK, STAGING_LINK } from "../../constant";
import PushNotiff from "./push/PushNotiff";
import Success from "./Success";
import Emergency from "./emergency/Emergency";
import PopUps from "./popups/PopUps";
import Sliders from "./slider/Sliders";
import { useAuth } from "../../context/auth-context";
import { FaTimesCircle } from "react-icons/fa";

const AdvanceNotiff = () => {
  //Advance Notification
  const { setOpenBroadcast } = useAuth();
  const [pushModal, setPushModal] = useState<boolean>(false);
  const [emergencyModal, setEmergencyModal] = useState<boolean>(false);
  const [popUpModal, setPopUpModal] = useState<boolean>(false);
  const [sliderModal, setSliderModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  return (
    <div className="font-manrope w-full  h-full    bg-[#13181B] ">
      <div className="flex justify-end  lgss:px-10  px-5  mt-10 w-full items-center">
        <FaTimesCircle
          onClick={() => {
            setOpenBroadcast(false);
          }}
          className="text-[#78C2F7] text-[24px] cursor-pointer"
        />
      </div>
      <div className="w-full  h-full overflow-auto bg-[#13181B]">
        <div className="w-full px-5 pt-4 lgss:pt-8 mds:px-12 font-manrope lgss:px-10 pb-24 bg-[#13181B]">
          <div className=" w-full gap-4 grid grid-cols-1 md:grid-cols-2 lgss:grid-cols-4">
            <div
              onClick={() => setPushModal(true)}
              className="h-[310px] cursor-pointer  border rounded-xl border-[#2C363E] p-4 flex flex-col justify-center items-start bg-transparent"
            >
              <div className="w-full h-[169.7px]">
                <img
                  src={pushNotif}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-[#0A6AAF] text-[14px] mt-3">
                Push Notification
              </h4>
              <h4 className="text-[#A0A9AD] font-medium text-[13px] mt-3">
                Send push notification to the user
              </h4>
            </div>
            <div
              onClick={() => setEmergencyModal(true)}
              className="h-[310px] cursor-pointer  border rounded-xl border-[#2C363E] p-4 flex flex-col justify-center items-start bg-transparent"
            >
              <div className="w-full h-[169.7px]">
                <img
                  src={emergency}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-[#0A6AAF] text-[14px] mt-3">
                Emergency Alert
              </h4>
              <h4 className="text-[#A0A9AD] font-medium text-[13px] mt-3">
                Send emergency alert to the user
              </h4>
            </div>
            <div
              onClick={() => setPopUpModal(true)}
              className="h-[310px] cursor-pointer  border rounded-xl border-[#2C363E] p-4 flex flex-col justify-center items-start bg-transparent"
            >
              <div className="w-full h-[169.7px]">
                <img
                  src={popUp}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-[#0A6AAF] text-[14px] mt-3">
                Image Pop - Ups
              </h4>
              <h4 className="text-[#A0A9AD] font-medium text-[13px] mt-3">
                Send image pop-up to the user
              </h4>
            </div>
            <div
              onClick={() => setSliderModal(true)}
              className="h-[310px] cursor-pointer  border rounded-xl border-[#2C363E] p-4 flex flex-col justify-center items-start bg-transparent"
            >
              <div className="w-full h-[169.7px]">
                <img
                  src={sliders}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-[#0A6AAF] text-[14px] mt-3">
                Sliders
              </h4>
              <h4 className="text-[#A0A9AD] font-medium text-[13px] mt-3">
                Send sliders to the user
              </h4>
            </div>
          </div>
        </div>
      </div>
      {pushModal && (
        <PushNotiff
          setPushModal={setPushModal}
          setSuccessModal={setSuccessModal}
        />
      )}
      {emergencyModal && (
        <Emergency
          setEmergencyModal={setEmergencyModal}
          setSuccessModal={setSuccessModal}
        />
      )}
      {popUpModal && (
        <PopUps
          setPopUpModal={setPopUpModal}
          setSuccessModal={setSuccessModal}
        />
      )}
      {sliderModal && (
        <Sliders
          setSliderModal={setSliderModal}
          setSuccessModal={setSuccessModal}
        />
      )}
      {successModal && <Success setSuccessModal={setSuccessModal} />}
    </div>
  );
};

export default AdvanceNotiff;
